$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let location_id = $("body").attr("event_id");
  let product_group_unique_id = $("body").attr("product_group_unique_id");
  let url = "";
  let status = 1;

  if (p === "product_group_unique" && a === "update") {
    let order_by = "name";
    let order_by_direction = "asc";

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      let page = parseInt($(this).attr("href").substring(6));

      getProductList(
        product_group_unique_id,
        page,
        order_by,
        order_by_direction,
        1,
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();

      let page = parseInt(
        $("#product-group-unique-product-table").attr("data-page"),
      );
      order_by = $(this).attr("data-order-by");
      order_by_direction = $(this).attr("data-order-by-direction");

      getProductList(
        product_group_unique_id,
        page,
        order_by,
        order_by_direction,
        1,
      );
    });

    function getProductList(
      product_group_unique_id = null,
      page = 1,
      order_by,
      order_by_direction,
      status = 1,
    ) {
      $.ajax({
        url: "/api/v1/private/product-group-unique/search-product",
        type: "POST",
        data: {
          product_group_unique_id,
          page,
          order_by,
          order_by_direction,
          status,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#product-list-for-product-group-unique").empty();
            $("#product-list-for-product-group-unique").append(data.html);
            $("html, body").animate({ scrollTop: $("body").height() }, "slow");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
